// extracted by mini-css-extract-plugin
export default {"root":"FileListGalleryItemThumbnailFallback_root__3Iwxy"};